import apiClient from "../lib/api-client";

export interface NotificationPreferences {
  lowStockEnabled: boolean;
  lowStockThreshold: number;
  stockExpiryEnabled: boolean;
  stockExpiryDays: number;
}

export const notificationPreferenceService = {
  async get(): Promise<NotificationPreferences> {
    const { data } = await apiClient.get("/notification-preferences");
    return data;
  },

  async update(
    prefs: Partial<NotificationPreferences>,
  ): Promise<NotificationPreferences> {
    const { data } = await apiClient.put("/notification-preferences", prefs);
    return data;
  },
};
